import React from "react";
import "../styles/TuyenDung.css";
function TuyenDung() {
  return (
    <div className="about">
      <div className="tdBottom">
        <h1> Hưng Phú Tửu</h1>
<p>Nổi bật lên bởi lối décor thiên hướng Cổ Trang đặc trưng với những chi tiết gỗ và kính độc đáo, sang trọng kết hợp với một menu hơn 500 món độc - lạ cực kì thu hút.</p>
<p>Môi trường làm việc trẻ, năng động, chuyên nghiệp, khuyến khích sự phát triển của từng nhân viên.</p>
<p>Đãi ngộ tương xứng với năng lực, thăng tiến theo năng lực và sự cống hiến.</p>
<p>HIỆN HÀNG DƯƠNG QUÁN ĐANG TUYỂN DỤNG THÊM NHIỀU VỊ TRÍ HẤP DẪN. </p>

<table class="table">
      <thead>
      <tr>
      <th className="tuyen">Vị trí đang tuyển</th>
      <th className="soluong">Số Lượng</th>
    </tr>
      </thead>
      <tbody>
    <tr>
      <td>Phục vụ</td>
      <td>2</td>
    </tr>
    <tr>
      <td>Bảo vệ</td>
      <td>1</td>
    </tr>
    <tr>
      <td>Bếp</td>
      <td>4</td>
    </tr>
    <tr>
      <td>Tạp vụ</td>
      <td>2</td>
    </tr>
  </tbody>
   </table>
   
   
      </div>
    </div>
  );
}

export default TuyenDung;
